'use client';

import { useLocale } from './use-locale';
import { GAMES } from './registry';
import { GameCard } from './game-card';

const COPY = {
  zh: { title: '小游戏合集', subtitle: '挑一个开始玩吧', toggle: 'EN' },
  en: { title: 'Mini Games', subtitle: 'Pick one and play', toggle: '中文' },
} as const;

export function PortalHome() {
  const { locale, toggle } = useLocale();
  const t = COPY[locale];

  return (
    <main className="portal">
      <header className="portal-header">
        <div className="portal-title-group">
          <h1>{t.title}</h1>
          <p>{t.subtitle}</p>
        </div>
        <button type="button" className="portal-locale-toggle" onClick={toggle}>
          🌐 {t.toggle}
        </button>
      </header>

      <section className="portal-grid">
        {GAMES.map((game) => (
          <GameCard key={game.slug} game={game} locale={locale} />
        ))}
      </section>
    </main>
  );
}
